import { FormFlagSet } from '@axo/form/configs';
import { createChannelSnapshot } from '@axo/form/data-access/tracking';
import { loan_application_api } from '@axo/shared/data-access/api';
import { loan_application } from '@axo/shared/data-access/types';
import { getActiveExperiments } from '@axo/shared/services/feature-flags/getActiveExperiments';
import { cookieWithConverter } from '@axo/shared/util/cookie';
import { Handler } from '../api-orchestrator';
import { IPreconditions } from '../types/IPreconditions';

interface IDependencies {
  postLoanApplication: typeof loan_application_api.postLoanApplication;
  patchLoanApplication: typeof loan_application_api.patchLoanApplication;
}

export const loanApplicationHandlerFactory =
  ({
    postLoanApplication,
    patchLoanApplication,
  }: IDependencies): Handler<
    Partial<loan_application.LoanApplication>,
    IPreconditions
  > =>
  async ({ data, preconditions, baseUrl }) => {
    if (
      !preconditions.customerId ||
      !preconditions.customerJWT ||
      !data.MarketCountry
    )
      return { didSync: false };

    const api = {
      url: { service: baseUrl },
      token: preconditions.customerJWT,
    };

    if (preconditions.loanApplicationId) {
      await patchLoanApplication(api)(preconditions.loanApplicationId, data);
      return {
        didSync: true,
      };
    }

    const cookieValue = cookieWithConverter.get('axotc') as unknown;

    const channelSnapshot = createChannelSnapshot({
      searchParams: new URL(window.document.location.href).searchParams,
      completedSteps: [
        {
          name: preconditions.initialSnapshotStepName,
        },
      ],
      cookieData: cookieValue || {},
      domain: window.location.hostname,
      experiments: getActiveExperiments(FormFlagSet),
    });

    const loanApplication = await postLoanApplication(api)({
      ...data,
      Channels: [channelSnapshot],
      CustomerID: preconditions.customerId,
      Brand: preconditions?.brand,
    });

    return {
      didSync: true,
      newPreconditions: {
        loanApplicationId: loanApplication.ID,
        broker: loanApplication.Meta?.Broker,
      },
    };
  };
